import { createContext } from 'react';

export type LoadingEntry = {
  id: string;
  title?: string;
  description?: string;
};

export type LoadingOrchestratorApi = {
  register: (entry: LoadingEntry) => void;
  unregister: (id: string) => void;
};

export const LoadingOrchestratorContext = createContext<
  LoadingOrchestratorApi | undefined
>(undefined);
